import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-unmute",
  "use": "icon-unmute-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"icon-unmute\"><path d=\"M16.944 12.036L14.44 9.532l1.072-1.071 2.504 2.504 2.46-2.461 1.072 1.072-2.46 2.46 2.396 2.397-1.072 1.072-2.396-2.397-2.44 2.44-1.072-1.072 2.44-2.44zM8.91 9.09L13 5v15l-3.804-3.804H4V9.09h4.91z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol